import React from 'react';
import DateBox from 'devextreme-react/date-box';

const DispatchFilterBar = React.memo(function DispatchFilterBar({
    isShowDispatchFilter,
    searchFromDate,
    searchToDate,
    isVisiblePickupSchedules,
    isShowPickupSchedules,
    isShowPending,
    isShowInProcess,
    isShowCompleted,
    isShowCancelled,
    isShowAll,
    isSearchLoading,
    gridSearchText,
    onGridSearchChange,
    onGridSearchClear,
    onInputChange,
    onFromDateChange,
    onToDateChange,
    onSearch,
    onReset,
}) {
    return (
        <li className="ml-auto">
            <div className={isShowDispatchFilter === true ? "dispatchFilter displayBlock" : "dispatchFilter displayNone"}>
                <div className="df-row">

                    {/* Grid search */}
                    <div className="df-group df-group-search">
                        <span className="df-group-label"><i className="fas fa-search"></i> Grid Search</span>
                        <div className="df-section df-grid-search">
                            <div className="df-grid-search-wrap">
                                <i className="fas fa-search df-grid-search-icon"></i>
                                <input
                                    type="text"
                                    className="df-grid-search-input"
                                    placeholder="Search in grid..."
                                    value={gridSearchText}
                                    onChange={onGridSearchChange}
                                />
                                {gridSearchText && (
                                    <button type="button" className="df-grid-search-clear" onClick={onGridSearchClear} title="Clear search">
                                        <i className="fas fa-times"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="df-divider"></div>

                    {/* Date range section */}
                    <div className="df-group df-group-dates">
                        <span className="df-group-label"><i className="fas fa-calendar-alt"></i> Date Range</span>
                        <div className="df-section df-dates">
                            <div className="df-field">
                                <label className="df-label">From</label>
                                <DateBox type="date"
                                    name="fromDate"
                                    placeholder="mm/dd/yyyy"
                                    useMaskBehavior={true}
                                    defaultValue={searchFromDate}
                                    value={searchFromDate}
                                    onValueChanged={onFromDateChange}
                                    width="128px"
                                    acceptCustomValue={false}
                                />
                            </div>
                            <span className="df-date-arrow"><i className="fas fa-arrow-right"></i></span>
                            <div className="df-field">
                                <label className="df-label">To</label>
                                <DateBox type="date"
                                    name="toDate"
                                    placeholder="mm/dd/yyyy"
                                    useMaskBehavior={true}
                                    defaultValue={searchToDate}
                                    value={searchToDate}
                                    onValueChanged={onToDateChange}
                                    width="128px"
                                    acceptCustomValue={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="df-divider"></div>

                    {/* Ride status filter */}
                    {/* <div className="df-group df-group-status">
                        <span className="df-group-label"><i className="fas fa-filter"></i> Ride Status</span>
                        <div className="df-section df-checks">
                            <label className={isVisiblePickupSchedules === true ? `df-status-chip df-chip-pickup${isShowPickupSchedules ? ' active' : ''}` : "displayNone"} title="Show Pick-up Schedules">
                                <input type="checkbox" id="isShowPickupSchedules" name="isShowPickupSchedules" checked={isShowPickupSchedules} onChange={onInputChange} />
                                <i className="fas fa-map-marker-alt"></i> Pick-up
                            </label>
                            <label className={`df-status-chip df-chip-pending${isShowPending ? ' active' : ''}`} title="Pending Rides">
                                <input type="checkbox" id="isShowPending" name="isShowPending" checked={isShowPending} onChange={onInputChange} />
                                <i className="fas fa-clock"></i> Pending
                            </label>
                            <label className={`df-status-chip df-chip-inprocess${isShowInProcess ? ' active' : ''}`} title="In-Process Rides">
                                <input type="checkbox" id="isShowInProcess" name="isShowInProcess" checked={isShowInProcess} onChange={onInputChange} />
                                <i className="fas fa-car"></i> In-Process
                            </label>
                            <label className={`df-status-chip df-chip-completed${isShowCompleted ? ' active' : ''}`} title="Completed Rides">
                                <input type="checkbox" id="isShowCompleted" name="isShowCompleted" checked={isShowCompleted} onChange={onInputChange} />
                                <i className="fas fa-check-circle"></i> Completed
                            </label>
                            <label className={`df-status-chip df-chip-cancelled${isShowCancelled ? ' active' : ''}`} title="Cancelled Rides">
                                <input type="checkbox" id="isShowCancelled" name="isShowCancelled" checked={isShowCancelled} onChange={onInputChange} />
                                <i className="fas fa-times-circle"></i> Cancelled
                            </label>
                            <label className={`df-status-chip df-chip-all${isShowAll ? ' active' : ''}`} title="All Rides">
                                <input type="checkbox" id="isShowAll" name="isShowAll" checked={isShowAll} onChange={onInputChange} />
                                <i className="fas fa-layer-group"></i> All
                            </label>
                        </div>
                    </div> */}

                    <div className="df-group df-group-status">
                        <span className="df-group-label"><i className="fas fa-filter"></i> Ride Status</span>
                        <div className="df-section df-checks">
                            <label className={isVisiblePickupSchedules === true ? `df-status-chip df-chip-pickup${isShowPickupSchedules ? ' active' : ''}` : "displayNone"} title="Show Pick-up Schedules">
                                <input type="checkbox" id="isShowPickupSchedules" name="isShowPickupSchedules" checked={isShowPickupSchedules} onChange={onInputChange} />
                                <i className="fas fa-map-marker-alt"></i> Pick-up
                            </label>
                            {/* <label className={`df-status-chip df-chip-pending${isShowPending ? ' active' : ''}`} title="Pending Rides">
                                <input type="checkbox" id="isShowPending" name="isShowPending" checked={isShowPending} onChange={onInputChange} />
                                <i className="fas fa-clock"></i> Pending
                            </label> */}
                            <label style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', height: 30, margin: 0,
                                background: isShowPending ? '#f5f3ff' : '#f5f5f5',
                                border: `1px solid ${isShowPending ? '#7c3aed' : '#ccc'}`,
                                borderRadius: 14, fontSize: 13,
                                color: isShowPending ? '#7c3aed' : '#555',
                                fontWeight: 600, cursor: 'pointer', userSelect: 'none',
                                whiteSpace: 'nowrap'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={isShowPending}
                                    onChange={onInputChange}
                                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                                    id="isShowPending"
                                    name="isShowPending"
                                />
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 15, height: 15, flexShrink: 0,
                                    border: `2px solid ${isShowPending ? '#7c3aed' : '#aaa'}`,
                                    borderRadius: 3,
                                    background: isShowPending ? '#7c3aed' : '#fff',
                                    color: '#fff', fontSize: 10, lineHeight: 1
                                }}>
                                    {isShowPending && '✓'}
                                </span>
                                <i className="fas fa-clock" style={{ fontSize: 11 }}></i>
                                Pending
                            </label>
                            {/* <label className={`df-status-chip df-chip-inprocess${isShowInProcess ? ' active' : ''}`} title="In-Process Rides">
                                <input type="checkbox" id="isShowInProcess" name="isShowInProcess" checked={isShowInProcess} onChange={onInputChange} />
                                <i className="fas fa-car"></i> In-Process
                            </label> */}
                            <label style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', height: 30, margin: 0,
                                background: isShowInProcess ? '#fff3e0' : '#f5f5f5',
                                border: `1px solid ${isShowInProcess ? '#e65100' : '#ccc'}`,
                                borderRadius: 14, fontSize: 13,
                                color: isShowInProcess ? '#e65100' : '#555',
                                fontWeight: 600, cursor: 'pointer', userSelect: 'none',
                                whiteSpace: 'nowrap'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={isShowInProcess}
                                    //onChange={(e) => this.setState({ isShowInProcess: e.target.checked })}
                                    onChange={onInputChange}
                                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                                    id="isShowInProcess" 
                                    name="isShowInProcess"
                                />
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 15, height: 15, flexShrink: 0,
                                    border: `2px solid ${isShowInProcess ? '#e65100' : '#aaa'}`,
                                    borderRadius: 3,
                                    background: isShowInProcess ? '#e65100' : '#fff',
                                    color: '#fff', fontSize: 10, lineHeight: 1
                                }}>
                                    {isShowInProcess && '✓'}
                                </span>
                                <i className="fas fa-car" style={{ fontSize: 11 }}></i>
                               In-Process
                            </label>
                            {/* <label className={`df-status-chip df-chip-completed${isShowCompleted ? ' active' : ''}`} title="Completed Rides">
                                <input type="checkbox" id="isShowCompleted" name="isShowCompleted" checked={isShowCompleted} onChange={onInputChange} />
                                <i className="fas fa-check-circle"></i> Completed
                            </label> */}
                            <label style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', height: 30, margin: 0,
                                background: isShowCompleted ? '#f0fdf4' : '#f5f5f5',
                                border: `1px solid ${isShowCompleted ? '#16a34a' : '#ccc'}`,
                                borderRadius: 14, fontSize: 13,
                                color: isShowCompleted ? '#16a34a' : '#555',
                                fontWeight: 600, cursor: 'pointer', userSelect: 'none',
                                whiteSpace: 'nowrap'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={isShowCompleted}
                                    onChange={onInputChange}
                                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                                    id="isShowCompleted"
                                    name="isShowCompleted"
                                />
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 15, height: 15, flexShrink: 0,
                                    border: `2px solid ${isShowCompleted ? '#16a34a' : '#aaa'}`,
                                    borderRadius: 3,
                                    background: isShowCompleted ? '#16a34a' : '#fff',
                                    color: '#fff', fontSize: 10, lineHeight: 1
                                }}>
                                    {isShowCompleted && '✓'}
                                </span>
                                <i className="fas fa-check-circle" style={{ fontSize: 11 }}></i>
                                Completed
                            </label>
                            {/* <label className={`df-status-chip df-chip-cancelled${isShowCancelled ? ' active' : ''}`} title="Cancelled Rides">
                                <input type="checkbox" id="isShowCancelled" name="isShowCancelled" checked={isShowCancelled} onChange={onInputChange} />
                                <i className="fas fa-times-circle"></i> Cancelled
                            </label> */}
                            <label style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', height: 30, margin: 0,
                                background: isShowCancelled ? '#fef2f2' : '#f5f5f5',
                                border: `1px solid ${isShowCancelled ? '#ef4444' : '#ccc'}`,
                                borderRadius: 14, fontSize: 13,
                                color: isShowCancelled ? '#ef4444' : '#555',
                                fontWeight: 600, cursor: 'pointer', userSelect: 'none',
                                whiteSpace: 'nowrap'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={isShowCancelled}
                                    onChange={onInputChange}
                                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                                    id="isShowCancelled"
                                    name="isShowCancelled"
                                />
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 15, height: 15, flexShrink: 0,
                                    border: `2px solid ${isShowCancelled ? '#ef4444' : '#aaa'}`,
                                    borderRadius: 3,
                                    background: isShowCancelled ? '#ef4444' : '#fff',
                                    color: '#fff', fontSize: 10, lineHeight: 1
                                }}>
                                    {isShowCancelled && '✓'}
                                </span>
                                <i className="fas fa-times-circle" style={{ fontSize: 11 }}></i>
                                Cancelled
                            </label>
                            <label style={{
                                display: 'inline-flex', alignItems: 'center', gap: 6,
                                padding: '4px 12px', height: 30, margin: 0,
                                background: isShowAll ? '#eff6ff' : '#f5f5f5',
                                border: `1px solid ${isShowAll ? '#3b82f6' : '#ccc'}`,
                                borderRadius: 14, fontSize: 13,
                                color: isShowAll ? '#3b82f6' : '#555',
                                fontWeight: 600, cursor: 'pointer', userSelect: 'none',
                                whiteSpace: 'nowrap'
                            }}>
                                <input
                                    type="checkbox"
                                    checked={isShowAll}
                                    onChange={onInputChange}
                                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                                    id="isShowAll"
                                    name="isShowAll"
                                />
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 15, height: 15, flexShrink: 0,
                                    border: `2px solid ${isShowAll ? '#3b82f6' : '#aaa'}`,
                                    borderRadius: 3,
                                    background: isShowAll ? '#3b82f6' : '#fff',
                                    color: '#fff', fontSize: 10, lineHeight: 1
                                }}>
                                    {isShowAll && '✓'}
                                </span>
                                <i className="fas fa-layer-group" style={{ fontSize: 11 }}></i>
                                All
                            </label>
                            {/* <label className={`df-status-chip df-chip-all${isShowAll ? ' active' : ''}`} title="All Rides">
                                <input type="checkbox" id="isShowAll" name="isShowAll" checked={isShowAll} onChange={onInputChange} />
                                <i className="fas fa-layer-group"></i> All
                            </label> */}
                        </div>
                    </div>

                    <div className="df-divider"></div>                    

                    {/* Action buttons */}
                    <div className="df-section df-actions" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '4px' }}>
                        <button type="submit" className="df-btn-search" onClick={onSearch} data-slide="true">
                            {isSearchLoading
                                ? <span><i className="fas fa-spinner fa-spin"></i> Searching...</span>
                                : <span><i className="fas fa-search"></i> Search</span>}
                        </button>
                        <button type="button" className="df-btn-reset" onClick={onReset} data-slide="true">
                            <i className="fas fa-undo"></i> Reset
                        </button>
                    </div>

                </div>
            </div>
        </li>
    );
});

export default DispatchFilterBar;
